import Vue from 'vue';
import { Message } from 'element-ui';
import { map as _map } from 'lodash';

const state = {
  applicationItemTrend: [{ clients: 0, messages: 0, alarms: 0, triggers: 0, stored_at: '2017-01-01' }],
  applicationList: [],
  page: 1,
  total: 0,
  applicationData: {
    name: '',
    id: '',
    created_at: '',
    summary: [],
    asset_limit: 0,
  },
  groups: [],
  categories: [],
  clientItem: {},
  messageClientQueryForm: { q: '', group_id: null, tags: '', online: 'all' },
  messageClientCurrentPage: 1,
};

const Loading = {};

const getters = {};

const actions = {
  // 获取应用列表
  APPLICATION_GET_LIST({ commit }) {
    Vue.http.get('application', {
      page: state.page,
    }).then((response) => {
      commit('APPLICATION_SET_LIST', { ...response.data });
    }, (response) => {
      Vue.iot.resp(response);
    });
  },
  APPLICATION_POST_ITEM({ dispatch, commit }, payload) {
    Vue.http.post('application', payload).then(() => {
      Message({
        showClose: true,
        message: '成功新增应用',
        type: 'success',
        duration: '1500',
      });
    }, (response) => {
      Vue.iot.resp(response);
    });
  },
  APPLICATION_PUT_ITEM({ commit, dispatch }, payload) {
    Vue.http.put(`application/${payload.id}`, payload).then(() => {
      Message({
        duration: 1500,
        type: 'success',
        message: '成功修改应用信息',
      });
    }, (response) => {
      Vue.iot.resp(response);
    });
  },
  APPLICATION_DELETE_ITEM({ dispatch }, payload) {
    Vue.http.delete(`application/${payload.id}`).then(() => {
      dispatch('APPLICATION_GET_LIST');
      Message({
        duration: 1500,
        type: 'success',
        message: '成功删除应用',
      });
    }, (response) => {
      Vue.iot.resp(response);
    });
  },
  // delete item
  APPLICATION_DELETE({ dispatch, commit }, id) {
    if (id) {
      Vue.http.delete(`application/${id}`).then(() => {
        dispatch('APPLICATION_GET_LIST');
      }, () => {
      });
    } else {
      Message({
        showClose: true,
        message: '未指定记录id',
        type: 'warning',
      });
    }
  },
  APPLICATION_GET_ITEM({ commit }, payload) {
    if (Loading[payload.id]) { // 很弱智的并发控制
      return;
    }
    Loading[payload.id] = true;
    Vue.http.get(`application/${payload.id}`, { params: payload.params }).then((response) => {
      commit('APPLICATION_SET_ITEM', response.data);
      commit('APPLICATION_SET_ITEM_TREND', { data: response.data.trends });
    }, (response) => {
      Vue.iot.resp(response);
    }).finally(() => {
      delete Loading[payload.id];
    });
  },
};

const mutations = {
  APPLICATION_SET_PAGE(state, { page }) {
    state.page = page;
  },
  APPLICATION_SET_LIST(state, payload) {
    state.applicationList = _map(payload.data, d => (d.summary ? d : { ...d, summary: {} }));
    state.total = payload.total;
  },
  APPLICATION_SET_ITEM(state, payload) {
    state.applicationData = payload;
    state.groups = payload.groups;
    state.categories = payload.categories;
  },
  APPLICATION_SET_ITEM_TREND(state, { data }) {
    state.applicationItemTrend = data;
  },
  // 修改message页面的client搜索
  APPLICATION_SET_MSG_CLIENT_QUERY(state, payload) {
    state.messageClientQueryForm = payload;
  },
  // 修改message页面的当前页
  APPLICATION_SET_MSG_CLIENT_PAGE(state, payload) {
    state.messageClientCurrentPage = payload.currentPage;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
